const autoNgTemplateLoaderTemplate1 = require('./volumeBrowser.html');

import angular from 'angular';

import { VolumeBrowserController } from './volumeBrowserController';

angular.module('portainer.agent').component('volumeBrowser', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: VolumeBrowserController,
  bindings: {
    volumeId: '<',
    nodeName: '<',
    isUploadEnabled: '<',
    endpointId: '<',
  },
});
